import {
  ANALYTICS_PRODUCT_NOT_APPLICABLE,
  AnalyticsData,
  AnalyticsService,
  NotAvailable,
  sendCustomDataEventToAnalytics,
  sendCustomEventToAnalytics,
  sendPageViewEventToAnalytics,
} from '@ui-common/analytics'

import { EditableStep, WizardStep } from '../wizard/wizardMachine'
import {
  IfpLoansAnalyticsModalName,
  IfpLoansCustomEventName,
  IfpLoansModalViewEventName,
  IfpPageViewEventName,
} from './types'

const wizardStepToPageViewEventNameMap = {
  [WizardStep.EntryStep]: 'EntryStep',
  [WizardStep.GetApplicationStep]: 'GetApplicationStep',
  [WizardStep.StatusStep]: 'StatusStep',
  [WizardStep.IfpInfoStep]: 'IfpInfoStep',
  [WizardStep.HouseholdInfoStep]: 'HouseholdInfoStep',
  [WizardStep.ApplicantInfoStep]: 'ApplicantInfoStep',
  [WizardStep.CancelApplicationStep]: 'CancelApplicationStep',
  [WizardStep.SendStep]: 'SendStep',
  [WizardStep.ReturnApplicationStep]: 'ReturnApplicationStep',
  [WizardStep.EndStep]: 'EndStep',
} satisfies Record<WizardStep, IfpPageViewEventName>

type WizardStepToPageViewEventNameMap = typeof wizardStepToPageViewEventNameMap

export class IfpLoansAnalyticsService extends AnalyticsService<
  IfpPageViewEventName,
  IfpLoansCustomEventName,
  IfpLoansAnalyticsModalName
> {
  constructor(private readonly data?: AnalyticsData) {
    super()
  }

  getCommonData = (): AnalyticsData => {
    return (
      this.data ?? {
        src: NotAvailable,
        flow: NotAvailable,
        product: ANALYTICS_PRODUCT_NOT_APPLICABLE,
        version: NotAvailable,
        ui_lang: NotAvailable,
      }
    )
  }

  sendPageViewEvent = (step: IfpPageViewEventName): void => {
    sendPageViewEventToAnalytics(step, this.getCommonData())
  }

  sendCustomDataEvent = (data: { [p: string]: string }): void => {
    sendCustomDataEventToAnalytics(data)
  }

  sendCustomEvent = (view: IfpPageViewEventName | IfpLoansModalViewEventName, name: IfpLoansCustomEventName): void => {
    sendCustomEventToAnalytics(view, name, this.getCommonData())
  }

  sendModalViewEvent = (modal: IfpLoansModalViewEventName): void => {
    sendPageViewEventToAnalytics(modal, this.getCommonData())
  }

  sendWizardStepCustomEvent = (step: WizardStep, name: IfpLoansCustomEventName): void => {
    this.sendCustomEvent(getAnalyticsNameForPage(step), name)
  }

  public sendPageEditActionEvent = (step: EditableStep, index?: number): void => {
    const eventIndex = typeof index === 'number' ? `(${index + 1}) ` : ''
    sendCustomEventToAnalytics(
      wizardStepToPageViewEventNameMap[WizardStep.StatusStep],
      `${eventIndex}${wizardStepToPageViewEventNameMap[step]}EditLink`,
      this.getCommonData(),
    )
  }
}

export const getAnalyticsNameForPage = <T extends WizardStep>(name: T): WizardStepToPageViewEventNameMap[T] => {
  return wizardStepToPageViewEventNameMap[name]
}
